export default __webpack_public_path__ + "static/media/mobile_colony_status.7a109912.png";